import Header from '../../../__Layout/Header';
import React , {useState} from "react";
import Loader from '../../../utils/Loader';
import { useLongQuestionsResultQuery } from "../../../Services/api";
import {pageSize} from "../../../utils/constants/constants";
import {Link } from 'react-router-dom';
import UploadMocResult from "./UploadMocResult";
export default function UserResult() {
    const [page, setPage] = useState(0);
    const [search, setSearch] = useState("");
    const {
        data: longQuestionsResult,
        isLoading: isGetLoading,
      } = useLongQuestionsResultQuery({ params:  {search,page,pageSize}  });
      
      const getPrevious= () => {
        setPage(page-1);
        setSearch("");
      }
      const getNext=()=>{
        setPage(page+1);
        setSearch("");
      }
      const findSearch=(e)=>{
        setPage(0);
        setSearch(e.target.value);
      }
      const [resultId,setResultId] = useState(0);
      const [courseId,setCourseId] = useState(0);
      const [studentId,setStudentId] = useState(0);
      if(isGetLoading) return  <Loader></Loader>
      return (
        <div className="vehicleCategories">
            <Header />
            <main id="main" className="main">
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">Mock Exam List</h5>
                    <ul className="nav nav-tabs nav-tabs-bordered d-flex" id="borderedTabJustified" role="tablist">
                       <li className="nav-item flex-fill" role="presentation">
                        <button className="nav-link w-100 active" id="home-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-home" type="button" role="tab" aria-controls="home" aria-selected="true">Mock Exam List </button>
                        </li>
                      
                    </ul>
                    <div className="tab-content pt-2" id="borderedTabJustifiedContent">
                        <div className="tab-pane fade show active" id="bordered-justified-home" role="tabpanel" aria-labelledby="home-tab"> 
                            <section className="section">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <h5 className="card-title">Mock Exam List</h5>
                                                <div className='row'>
                                                    <div className='col-lg-8'></div>
                                                    <div className='col-lg-4'>
                                                        <div className="datatable-search pull-right">
                                                            <input className="datatable-input" placeholder="Search..." type="search" title="Search within table" onChange={findSearch}/>
                                                        </div>
                                                    </div>
                                                </div>
                                                <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th>#</th>
                                                                <th className='text-capitalize'>student</th>
                                                                <th className='text-capitalize'>course name</th>
                                                                {/* <th className='text-capitalize'>Senario</th> */}
                                                                <th className='text-capitalize'>Status</th>
                                                                <th className='text-capitalize'>Detail</th>
                                                                
                                                                {/* <th className='text-capitalize'>Upload Result</th> */}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            
                                                        {
                                                            longQuestionsResult?.data?.data_array?.map((item,index) => {
                                                                
                                                            return (
                                                                <tr key={index}>
                                                                    <th scope="row">{index+1}</th>
                                                                    <td>{item?.student?.first_name} {item?.student?.last_name} </td>
                                                                    <td>{item?.course?.course_name}</td>
                                                                    <td>{item.status}</td>
                                                                    <td><Link style={{'fontSize':'12px'}} to={`/user-result-detail/${item?.student?.student_id}`} className="btn btn-dark">Detail</Link></td>
                                                                    <td><Link style={{'fontSize':'12px'}} to={`${process.env.REACT_APP_BACKEND_URL_LIVE}/word-file/${item?.student?.student_id}`} target="_blanck" className="btn btn-dark">Download File</Link></td>
                                                                    <td>
                                                                        <button className="btn btn-dark " style={{'fontSize':'12px'}} data-bs-toggle="modal" onClick={()=>{setResultId(item.lqr_id); setStudentId(item?.student?.student_id); setCourseId(item?.course?.course_id)} } data-id={item.lqr_id} data-bs-target="#fullscreenModal" >
                                                                            Upload Result
                                                                        </button>
                                                                    </td>
                                                                    <td><Link style={{'fontSize':'12px'}} to={item?.moc_exam_result?.file} target="_blanck" className="btn btn-dark">Download Result</Link></td>

                                                                </tr>                                            
                                                                )  
                                                            })  
                                                        } 
                                                        </tbody>
                                                </table>                        
                                                <nav aria-label="Page navigation example">
                                                    <ul className="pagination">
                                                    {longQuestionsResult?.data?.currentPage !==0 ? <li className="page-item"><button type="button" className="page-link" onClick={getPrevious}>Previous</button></li> :''}
                                                    <li className="page-item"> {longQuestionsResult?.data?.currentPage+1} </li>                                                  
                                                    <li className="page-item"> of {longQuestionsResult?.data?.totalPages}</li>
                                                    {longQuestionsResult?.data?.currentPage !==longQuestionsResult?.data?.totalPages ? <li className="page-item"><button type="button" className="page-link" onClick={getNext}>Next</button></li>:''}
                                                    </ul>
                                                </nav>
                                            </div>
                                        </div>
                                    </div>
                                    <UploadMocResult id={resultId} course_id={courseId} student_id={studentId}/>
                                </div>
                            </section>  
                        </div>
                        
                    </div>
                </div>
               
            </div>

            </main>
          
        </div>
    );
}
